










import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {nextTick} from "process"
import {PointerEventManager} from "../lib/pointereventmanager"

import elementResizeEvent from 'element-resize-event';

interface IScrollValues {
    scrollBarWidth: number,
    virtualWindowSize: number,
    realWindowSize: number,
    fractionOfContentVisible: number,
    distanceFromTheStartToTheScrollbar: number,
    widthOfScrollbar: number,
    distanceScrolled: number,
    minSize: number,
    scale: number,
};

@Component ({
    components: {

    }
})
export default class ScrollBar extends Vue{

    contentDiv:HTMLDivElement = null;
    contentDivBox = null;
    contentHeight:number = 0;
    scrollWindowBox = null;
    isExpanded:boolean = false;
    superiorArrow:string = null;
    inferiorArrow:string = null;
    isVisible:boolean = false;

    pointerEventsManager: PointerEventManager;

    scrollValues: IScrollValues = {
        scrollBarWidth: 0,
        virtualWindowSize: 0,
        realWindowSize: 0,
        fractionOfContentVisible: 1,
        distanceFromTheStartToTheScrollbar: 0,
        widthOfScrollbar: 0,
        distanceScrolled: 0,
        minSize: 0,
        scale: 1,
    }

    widgetHoverTimeout:NodeJS.Timer;
    widgetStyle: {
        width:string,
        height:string,
        left:string,
        top:string,
    } = {
        width: '3px',
        height: '3px',
        left: '10px',
        top: '10px'
    }
    contentStyle: {
        width: number,
        height: number,
    } = {
        width: 0,
        height: 0,
    }


    @Prop({}) isX : boolean;
    @Prop({}) infinite : boolean;
    @Prop({}) watchSize : number;
    @Prop({}) hiddenByParent : boolean;
    @Prop({}) bleedPermitted : boolean;
    // watch size is something tricky
    // it is the size of the content that is watched for changes
    // if it is updated elsewhere, this reflects that change

    @Prop({}) scrollableWindow: HTMLDivElement;

    scrollWindow:HTMLDivElement;
    scrollWindowHeight:number = 0;

    mounted(){



        if(this.scrollableWindow){
            this.scrollWindow = this.scrollableWindow;
            this.mountScrollable(this.scrollWindow);

            this.pointerEventsManager = new PointerEventManager(this.$refs.widget as HTMLElement,{
                pointerdown: true,
                pointermove: true,
            },["auto"],{
                pointerdown: false,
                pointermove: true,
            },false);

            let dragStartAt = null;
            let originalScroll = null
            this.pointerEventsManager.pointerDownEvents.push((ev,data) => {
                if(data.pointerType === "touch") {return;}

                ev.preventDefault();

                this.pointerEventsManager.capturePointer([ev]);
                if(this.isX) {
                    dragStartAt = ev.clientX;
                }
                else {
                    dragStartAt = ev.clientY;
                }
                originalScroll = this.getScrollPos();
            });
            
            this.pointerEventsManager.pointerMoveEvents.push((ev,data) => {
                if(data.pointerType === "touch") {return;}

                if(this.pointerEventsManager.isMouseDown) {
                    let curDrag;
                    if(this.isX) {
                        curDrag = ev.clientX;
                    }
                    else {
                        curDrag = ev.clientY;
                    }

                    if(dragStartAt !== null) {
                        this.scrollTo(originalScroll + ((curDrag - dragStartAt) * (this.scrollValues.virtualWindowSize / (this.scrollValues.realWindowSize-65))));
                    }

                    this.expandSize();
                }
                else if(dragStartAt !== null) {
                    dragStartAt = null;
                    this.pointerEventsManager.releasePointer([ev]);
                }
            });
        }
    }

    mountScrollable(win: HTMLDivElement) {
        if(this.scrollableWindow){
            this.scrollWindow = win;
            this.establishStyle();

            nextTick(() => {
                this.initiateContentDiv();
                this.manageScrollEvents();
                this.growVirtualWindow();
                setInterval(() => {
                    if(this.contentDiv.offsetHeight != this.contentHeight || this.scrollableWindow.offsetHeight != this.scrollWindowHeight){
                        this.contentHeight = this.contentDiv.offsetHeight;
                        this.scrollWindowHeight = this.scrollableWindow.offsetHeight;
                        this.shouldScroll(); 
                    }
                },400)
            })
        }   
    }

    shouldScroll(){
        this.updateScrollbarPosition()
        this.isVisible = (this.scrollValues.fractionOfContentVisible < 1);
    }

    establishStyle(){
        if(this.isX){
            this.superiorArrow = "keyboard_arrow_right";
            this.inferiorArrow = "keyboard_arrow_left";
        }else{
            this.superiorArrow = "keyboard_arrow_up";
            this.inferiorArrow = "keyboard_arrow_down";
        }
    }

    expandSize(){
        if(this.isX){
            this.widgetStyle.height = "15px";
        }else{
            this.widgetStyle.width = "15px";
        }
        this.isExpanded = true;

        clearTimeout(this.widgetHoverTimeout);

        this.widgetHoverTimeout = setTimeout(() => {
            if(this.isX){
                this.widgetStyle.height = "3px";
            }else{
                this.widgetStyle.width = "3px";
            }
            this.isExpanded = false;
        },1500);
    }

    initiateContentDiv(){
        this.adjustScrollbarOffset();

        this.contentDiv = this.scrollWindow?this.scrollWindow.childNodes[0] as HTMLDivElement:this.$el.offsetParent as HTMLDivElement;
        if(this.infinite){
            this.contentDiv = this.scrollWindow?this.scrollWindow.childNodes[0] as HTMLDivElement:this.$el.offsetParent as HTMLDivElement;
            this.contentStyle.width = this.scrollWindow.offsetWidth;
            this.contentStyle.height = this.scrollWindow.offsetHeight;

            this.contentDiv.style.width = this.scrollWindow.offsetWidth + 'px';
            this.contentDiv.style.height = this.scrollWindow.offsetHeight + 'px';
        }
    }

    adjustScrollbarOffset(){
        if(!this.scrollWindow) {return;}
        this.scrollWindow.style.overflow = "hidden";
        let scrollWidthWidthWITHOUTSCROLL = this.isX ? this.scrollWindow.clientHeight : this.scrollWindow.clientWidth;
        this.scrollWindow.style.overflowY = "scroll";
        let scrollWidthWidthWITHSCROLL = this.isX ? this.scrollWindow.clientHeight : this.scrollWindow.clientWidth;
        this.scrollValues.scrollBarWidth = scrollWidthWidthWITHOUTSCROLL - scrollWidthWidthWITHSCROLL;
        
        this.scrollWindow.style.marginRight = -(this.scrollValues.scrollBarWidth) + "px";
        this.scrollWindow.style.paddingRight = this.bleedPermitted ? '0px' : (this.scrollValues.scrollBarWidth) + "px";
        this.scrollWindow.parentElement.style.overflow = "hidden";
    }

    updateScrollbarPosition() {

        if(this.hiddenByParent){
            this.scrollWindow.parentElement.style.display = "block";
        }
        // this.scrollWindow.style.display = "block";
        // this.contentDiv.style.display = "block";

        let padding:number=0;
        if(this.infinite){
            padding = 500;
        }

        this.contentDivBox = this.contentDiv.getBoundingClientRect();
        this.scrollWindowBox = this.scrollWindow.getBoundingClientRect();

        this.scrollValues.virtualWindowSize = Math.max((this.isX ? this.contentDiv.scrollWidth : this.contentDiv.scrollHeight) - padding,this.scrollValues.minSize) * this.scrollValues.scale;
        this.scrollValues.realWindowSize = (this.isX ? this.scrollWindow.clientWidth : this.scrollWindow.clientHeight);
        this.scrollValues.fractionOfContentVisible = (this.scrollValues.realWindowSize / this.scrollValues.virtualWindowSize);

        if(this.isX){
            this.scrollValues.distanceScrolled = -(this.contentDivBox.left - this.scrollWindowBox.left);
        }else{
            this.scrollValues.distanceScrolled = -(this.contentDivBox.top - this.scrollWindowBox.top);
        }

        let perc = (this.scrollValues.distanceScrolled / (this.scrollValues.virtualWindowSize - this.scrollValues.realWindowSize));

        if(this.isX){
            this.widgetStyle.width = `${this.scrollValues.fractionOfContentVisible * 100}%`;
            this.widgetStyle.left = `${((1 - this.scrollValues.fractionOfContentVisible) * perc) * 100}%`;
            this.widgetStyle.top = "auto";
        }else{
            this.widgetStyle.height = `${this.scrollValues.fractionOfContentVisible * 100}%`;
            this.widgetStyle.top = `${((1 - this.scrollValues.fractionOfContentVisible) * perc) * 100}%`;
            this.widgetStyle.left = "auto";
        }

        if(this.hiddenByParent){
            this.scrollWindow.parentElement.style.display = "";
        }
        // this.scrollWindow.style.display = "";
        // this.contentDiv.style.display = "";

    }

    growVirtualWindow() {
        if(this.infinite){
            let maxScrollDist = this.scrollValues.virtualWindowSize - this.scrollValues.realWindowSize - this.scrollValues.scrollBarWidth;
            let leftToScroll = (maxScrollDist - this.scrollValues.distanceScrolled);

            let widgetBelowWindow = 0;
            if(leftToScroll < 0) {
                widgetBelowWindow = -(leftToScroll);
            }

            if(this.isX){
                if(typeof this.contentStyle.width === "number") {
                    this.contentStyle.width = (this.contentStyle.width + (widgetBelowWindow));
                    this.contentDiv.style.width = this.contentStyle.width + 'px';
                }
            }else{
                if(typeof this.contentStyle.height === "number") {
                    this.contentStyle.height = (this.contentStyle.height + (widgetBelowWindow));
                    this.contentDiv.style.height = this.contentStyle.height + 'px';
                }
            }
        }
    }

    scrollTo(pos: number) {
        if(this.isX) {
            this.scrollWindow.scrollLeft = pos;
        }
        else {
            this.scrollWindow.scrollTop = pos;
        }

        this.updateScrollbarPosition();
        this.growVirtualWindow();
        this.updateScrollbarPosition();
    }

    getScrollPos() {
        if(this.isX) {
            return this.scrollWindow.scrollLeft;
        }
        else {
            return this.scrollWindow.scrollTop;
        }
    }

    setMinBounds(size: number) {
        this.scrollValues.minSize = size;

        this.updateScrollbarPosition();
        this.growVirtualWindow();
        this.updateScrollbarPosition();
    }

    setScale(scale: number) {
        this.scrollValues.scale = scale;

        this.updateScrollbarPosition();
        this.growVirtualWindow();
        this.updateScrollbarPosition();
    }

    manageScrollEvents(){
        if(this.scrollWindow){
            this.scrollWindow.addEventListener('mousemove', (e) => {})
            this.scrollWindow.addEventListener('scroll', (e) => {
                this.updateScrollbarPosition();
                this.growVirtualWindow();
                this.updateScrollbarPosition();
            })
        }
    }

    @Watch('watchSize')
    reworkSizes(to, from){
        if(to && this.scrollableWindow){
            if(this.infinite){
                if(this.isX){
                    this.contentStyle.width = to;
                }else{
                    this.contentStyle.height = to;
                }
                this.growVirtualWindow();
                this.updateScrollbarPosition();
            }else{
                this.updateScrollbarPosition();
                this.growVirtualWindow();
                this.updateScrollbarPosition();
            }
        }
    }
}
